import React from 'react'
import PropTypes from 'prop-types'

import Quote from 'app/components/Quote'

import './styles.scss'

const baseClass = 'onboarding-view-examples-popup-card'

const SliderCard = ({ id, name, description, proQuote, proQuoteAuthor, image }) => (
  <div id={`${baseClass}-${id}`} className={baseClass}>
    <div className={`${baseClass}__title`}>{name}</div>
    <div className={`${baseClass}__text`}>{description}</div>
    <Quote proQuote={proQuote} proQuoteAuthor={proQuoteAuthor} image={image} />
  </div>
)

SliderCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  proQuoteAuthor: PropTypes.string,
  image: PropTypes.string,
  proQuote: PropTypes.string,
}

export default SliderCard
